import type { ReactNode } from "react";
import classNames from "classnames";
import { If } from "../If";

interface ModalBodyProps {
  children?: ReactNode;
  className?: string;
  title?: string;
}

export const ModalBody = ({ title, children, className }: ModalBodyProps) => (
  <div className={classNames("modal__body", className)}>
    <If condition={!!title}>
      <h2 className="modal__title">${title}</h2>
    </If>
    <div className="modal__description">{children}</div>
  </div>
);
